import React,{useRef,useEffect} from 'react';

import { useHistory } from 'react-router-dom';
// the hook
import { observer } from 'mobx-react';
import {useTranslation} from 'react-i18next';
import { http, addVisitLog, history } from 'libs';
import Login from '../login/index';
import Register from '../login/register';
import ForgetPassword from '../login/forgetPassword';
import gStore from 'store';

import style from './index.module.less'
import banner_logo from './banner_logo.png';
import banner_drop from './banner_drop.png';
import water_drop from './water_drop.png';

export default observer(function () {
  const {t, i18n} = useTranslation();// {t('')}
  const route = useHistory();

  const startSelection = ()=>{
    // if(area === 'banner'){
      history.push('/home');
      // return
    // }
    // addVisitLog({
    //   pageName: '开始选品',
    //   fromPageUrl: window.referrerUrl,
    //   pageUrl:`${window.location.origin}${history.location.pathname}`,
    //   eventCode: 'ClickStartSelect',
    //   eventName: "开始选品",
    // })
    // history.push('./goods');
  }

  const startExperience = ()=>{
    addVisitLog({
      pageName: '开始体验',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: 'ClickStartExperience',
      eventName: "开始体验",
    })
    history.push('./goods');
  }

  const showServiceIntroduce = ()=>{
    addVisitLog({
      pageName: '查看服务介绍',
      fromPageUrl: window.referrerUrl,
      pageUrl:`${window.location.origin}${history.location.pathname}`,
      eventCode: 'ShowServiceIntroduce',
      eventName: "查看服务介绍",
    })
    history.push('./business');
  }


  useEffect(()=>{
    return ()=>{
      gStore.isLogin = false;
    }
  },[])
  
  let token = localStorage.getItem('token');
  return (
    <div className={style.homeContainer}>
      <div className='home_banner'>
        <div className="banner_logo">
          <img src={banner_logo} alt="" />
        </div>
        <div className="banner_drop">
          <img className='banner_drop' src={banner_drop} alt="" />
          <img className='water_drop' src={water_drop} alt="" />
          <div className='login_modal'>
            {history.location.pathname === '/login' ? <Login/> : null}
            {history.location.pathname === '/register' ? <Register/> : null}
            {history.location.pathname === '/forgetPassword' ? <ForgetPassword/> : null}
          </div>
        </div>
        <div className='handle_btn' onClick={()=>startSelection()}>{'点击进入首页 >'}</div>
      </div>
    </div>
  )
})
